export const initCameraMovement = [
  [0, 0, 3],
  [0, 0, 3.00001],
  [0, 0, 3.000068],
  [0, 0, 3.00018],
  [0, 0, 3.000328],
  [0, 0, 3.000507],
  [0, 0, 3.000677],
  [2.384186E-07, 0, 3.001023],
  [4.768372E-07, 0, 3.001329],
  [7.152557E-07, 0, 3.001708],
  [9.536743E-07, 0, 3.001903],
  [1.430511E-06, 0, 3.002441],
  [2.145767E-06, 0, 3.002899],
  [3.099442E-06, 0, 3.003458],
  [4.291534E-06, 0, 3.004112],
  [5.483627E-06, 0, 3.004709],
  [7.152557E-06, 0, 3.005363],
  [9.298325E-06, 0, 3.006059],
  [1.144409E-05, 0, 3.006724],
  [1.454353E-05, 0, 3.007585],
  [1.764297E-05, 0, 3.008394],
  [2.002716E-05, 0, 3.008906],
  [2.622604E-05, 0, 3.010204],
  [3.123283E-05, 0, 3.011132],
  [3.647804E-05, 0, 3.012042],
  [4.243851E-05, 0, 3.012977],
  [5.030632E-05, 0, 3.014135],
  [5.865097E-05, 0, 3.015261],
  [6.556511E-05, 0, 3.016143],
  [7.653236E-05, 0, 3.017445],
  [8.845329E-05, 0, 3.018762],
  [0.0001006126, 0, 3.020002],
  [0.0001163483, 0, 3.021518],
  [0.000130415, 0, 3.022778],
  [0.0001480579, 0, 3.024278],
  [0.0001659393, 0, 3.025702],
  [0.0001854897, 0, 3.027163],
  [0.0002069473, 0, 3.028696],
  [0.0002264977, 0, 3.030011],
  [0.0002548695, 0, 3.031846],
  [0.0002746582, 0, 3.033059],
  [0.0003044605, 0, 3.034804],
  [0.0003404617, 0, 3.036802],
  [0.0003736019, 0, 3.038549],
  [0.0004081726, 0, 3.040296],
  [0.0004467964, 0, 3.042159],
  [0.0004820824, 0, 3.043789],
  [0.0005347729, 0, 3.04612],
  [0.0005803108, 0, 3.048052],
  [0.0006289482, 0, 3.050025],
  [0.0006835461, 0, 3.052144],
  [0.0007276535, 0, 3.053804],
  [0.0007956028, 0, 3.056258],
  [0.0008597374, 0, 3.058481],
  [0.0009195805, 0, 3.060484],
  [0.000982523, 0, 3.062517],
  [0.00106287, 0, 3.065025],
  [0.001125574, 0, 3.066915],
  [0.001218081, 0, 3.069607],
  [0.001302004, 0, 3.071964],
  [0.001400709, 0, 3.074639],
  [0.001496077, 0, 3.077139],
  [0.001598597, 0, 3.079741],
  [0.001692772, 0, 3.082051],
  [0.001788616, 0, 3.08434],
  [0.001897097, 0, 3.086863],
  [0.002035141, 0, 3.089965],
  [0.002151012, 0, 3.092487],
  [0.002226353, 0, 3.094096],
  [0.002400875, 0, 3.097708],
  [0.002570152, 0, 3.101094],
  [0.002659559, 0, 3.102836],
  [0.00283742, 0, 3.106219],
  [0.003008366, 0, 3.10937],
  [0.003205538, 0, 3.112892],
  [0.003348112, 0, 3.115376],
  [0.003549099, 0, 3.118787],
  [0.003717661, 0, 3.121569],
  [0.003932238, 0, 3.125027],
  [0.004108906, 0, 3.127802],
  [0.00436306, 0, 3.131692],
  [0.004558325, 0, 3.134604],
  [0.004791498, 0, 3.137999],
  [0.005033731, 0, 3.141443],
  [0.005272388, 0, 3.144752],
  [0.00552845, 0, 3.148221],
  [0.005699158, 0, 3.150488],
  [0.006066084, 0, 3.155254],
  [0.006338835, 0, 3.158699],
  [0.006608963, 0, 3.162042],
  [0.006932735, 0, 3.165957],
  [0.007245064, 0, 3.169647],
  [0.007557869, 0, 3.173265],
  [0.007866621, 0, 3.176763],
  [0.008183718, 0, 3.180284],
  [0.008569002, 0, 3.184471],
  [0.008909464, 0, 3.188095],
  [0.009236336, 0, 3.191506],
  [0.009679079, 0, 3.196034],
  [0.01005554, 0, 3.199801],
  [0.01042557, 0, 3.203436],
  [0.01085854, 0, 3.207607],
  [0.01126432, 0, 3.211442],
  [0.01171446, 0, 3.215616],
  [0.01221848, 0, 3.220193],
  [0.01264834, 0, 3.224021],
  [0.01312995, 0, 3.228234],
  [0.01362157, 0, 3.232455],
  [0.01405025, 0, 3.236074],
  [0.01461411, 0, 3.24075],
  [0.01511383, 0, 3.244817],
  [0.01570487, 0, 3.249544],
  [0.01618361, 0, 3.253305],
  [0.01685071, 0, 3.258454],
  [0.01737809, 0, 3.262452],
  [0.01808476, 0, 3.267715],
  [0.01858449, 0, 3.271373],
  [0.01934361, 0, 3.276837],
  [0.01993942, 0, 3.28105],
  [0.02044535, 0, 3.284578],
  [0.02133512, 0, 3.290676],
  [0.02201223, 0, 3.29523],
  [0.02273393, 0, 3.300008],
  [0.02344656, 0, 3.304649],
  [0.02423835, 0, 3.309725],
  [0.02498627, 0, 3.314441],
  [0.02534699, 0, 3.316689],
  [0.02659225, 0, 3.324332],
  [0.02741075, 0, 3.329256],
  [0.02816439, 0, 3.333724],
  [0.02901793, 0, 3.338712],
  [0.02996039, 0, 3.344133],
  [0.03085256, 0, 3.349185],
  [0.03179932, 0, 3.354466],
  [0.03232455, 0, 3.35736],
  [0.03364444, 0, 3.364531],
  [0.03461647, 0, 3.36972],
  [0.03569174, 0, 3.375374],
  [0.03653145, 0, 3.379728],
  [0.03763819, 0, 3.385391],
  [0.03879714, 0, 3.39123],
  [0.03948259, 0, 3.394642],
  [0.04094172, 0, 3.401803],
  [0.0420289, 0, 3.407055],
  [0.04319286, 0, 3.4126],
  [0.04445863, 0, 3.418544],
  [0.04530931, 0, 3.422489],
  [0.04680562, 0, 3.429339],
  [0.04811788, 0, 3.435254],
  [0.04921389, 0, 3.440129],
  [0.05050611, 0, 3.445807],
  [0.05145359, 0, 3.449922],
  [0.05298042, 0, 3.456472],
  [0.05465555, 0, 3.463547],
  [0.05533504, 0, 3.466385],
  [0.05701208, 0, 3.473313],
  [0.05881381, 0, 3.480638],
  [0.06038141, 0, 3.486917],
  [0.06156445, 0, 3.491601],
  [0.06335068, 0, 3.498583],
  [0.06487846, 0, 3.504474],
  [0.06599855, 0, 3.508748],
  [0.06805754, 0, 3.516505],
  [0.06969142, 0, 3.522574],
  [0.07138276, 0, 3.52878],
  [0.07295704, 0, 3.534486],
  [0.0742383, 0, 3.539082],
  [0.07645917, 0, 3.546952],
  [0.07823443, 0, 3.553157],
  [0.07934189, 0, 3.55699],
  [0.08183789, 0, 3.565528],
  [0.08371186, 0, 3.571847],
  [0.08558369, 0, 3.578086],
  [0.08751869, 0, 3.58446],
  [0.08949471, 0, 3.590892],
  [0.0914731, 0, 3.597256],
  [0.09343076, 0, 3.603483],
  [0.09551835, 0, 3.610046],
  [0.09760141, 0, 3.616521],
  [0.09979463, 0, 3.623257],
  [0.1011295, 0, 3.62732],
  [0.1036389, 0, 3.634878],
  [0.1062477, 0, 3.642633],
  [0.1074309, 0, 3.646117],
  [0.1108501, 0, 3.656069],
  [0.1131563, 0, 3.662689],
  [0.115499, 0, 3.669339],
  [0.1176312, 0, 3.675328],
  [0.120327, 0, 3.682819],
  [0.1219738, 0, 3.687349],
  [0.1250257, 0, 3.695658],
  [0.1274157, 0, 3.702089],
  [0.1303763, 0, 3.709965],
  [0.1326804, 0, 3.716027],
  [0.1354904, 0, 3.723342],
  [0.1368172, 0, 3.726768],
  [0.1409473, 0, 3.737315],
  [0.1437221, 0, 3.744307],
  [0.1463387, 0, 3.750832],
  [0.1490941, 0, 3.757634],
  [0.1522059, 0, 3.765233],
  [0.1549311, 0, 3.771817],
  [0.157485, 0, 3.77793],
  [0.1603374, 0, 3.784693],
  [0.1640537, 0, 3.793403],
  [0.1659532, 0, 3.797813],
  [0.1700311, 0, 3.807186],
  [0.172888, 0, 3.813677],
  [0.1760318, 0, 3.820752],
  [0.1797633, 0, 3.829057],
  [0.1830611, 0, 3.836316],
  [0.1861656, 0, 3.843082],
  [0.1894042, 0, 3.850073],
  [0.1929998, 0, 3.857756],
  [0.1962705, 0, 3.864674],
  [0.2000208, 0, 3.872526],
  [0.2032106, 0, 3.879138],
  [0.2068229, 0, 3.886555],
  [0.2105565, 0, 3.894143],
  [0.2140439, 0, 3.901161],
  [0.2178793, 0, 3.908804],
  [0.2201133, 0, 3.913219],
  [0.2250311, 0, 3.922848],
  [0.2292295, 0, 3.930973],
  [0.2328322, 0, 3.937876],
  [0.2371178, 0, 3.946006],
  [0.2411273, 0, 3.953535],
  [0.2449138, 0, 3.960577],
  [0.2472715, 0, 3.96493],
  [0.2527359, 0, 3.974925],
  [0.2570035, 0, 3.982642],
  [0.2616935, 0, 3.991035],
  [0.2649531, 0, 3.996816],
  [0.2700961, 0, 4.00585],
  [0.2735691, 0, 4.011893],
  [0.2788954, 0, 4.021071],
  [0.2834723, 0, 4.028873],
  [0.2867048, 0, 4.034338],
  [0.2919989, 0, 4.043208],
  [0.2967808, 0, 4.051136],
  [0.2998149, 0, 4.056125],
  [0.3061802, 0, 4.066493],
  [0.3081443, 0, 4.069665],
  [0.3144388, 0, 4.079748],
  [0.3207612, 0, 4.089751],
  [0.3233471, 0, 4.093807],
  [0.3303671, 0, 4.104716],
  [0.3354421, 0, 4.112513],
  [0.3405151, 0, 4.120232],
  [0.3441837, 0, 4.125769],
  [0.3508801, 0, 4.135781],
  [0.356091, 0, 4.143488],
  [0.3610959, 0, 4.150823],
  [0.3665972, 0, 4.158809],
  [0.3719635, 0, 4.166527],
  [0.3771305, 0, 4.173889],
  [0.3830051, 0, 4.182181],
  [0.3872557, 0, 4.188129],
  [0.3933153, 0, 4.196536],
  [0.399668, 0, 4.205258],
  [0.4054842, 0, 4.213163],
  [0.4112401, 0, 4.220914],
  [0.4160495, 0, 4.227334],
  [0.4226842, 0, 4.236111],
  [0.4286652, 0, 4.243943],
  [0.4333885, 0, 4.250077],
  [0.4400592, 0, 4.258663],
  [0.4465203, 0, 4.266895],
  [0.4509342, 0, 4.272472],
  [0.4587724, 0, 4.282284],
  [0.4649284, 0, 4.28991],
  [0.4718709, 0, 4.298427],
  [0.477746, 0, 4.305566],
  [0.4838767, 0, 4.31295],
  [0.4909792, 0, 4.321424],
  [0.4971633, 0, 4.328731],
  [0.5042944, 0, 4.337077],
  [0.5108936, 0, 4.344727],
  [0.5175748, 0, 4.352398],
  [0.5216918, 0, 4.357091],
  [0.5312247, 0, 4.367853],
  [0.5376961, 0, 4.37508],
  [0.5444217, 0, 4.382523],
  [0.5521147, 0, 4.390954],
  [0.5591407, 0, 4.398578],
  [0.5652108, 0, 4.405107],
  [0.5735991, 0, 4.414045],
  [0.5784686, 0, 4.419188],
  [0.5880029, 0, 4.429164],
  [0.5940213, 0, 4.435398],
  [0.6025257, 0, 4.444124],
  [0.6073811, 0, 4.449064],
  [0.6175728, 0, 4.459334],
  [0.6247838, 0, 4.466521],
  [0.6328378, 0, 4.474472],
  [0.6411519, 0, 4.482595],
  [0.6490014, 0, 4.490189],
  [0.6554954, 0, 4.496415],
  [0.6642063, 0, 4.50469],
  [0.6681347, 0, 4.508393],
  [0.6779268, 0, 4.517546],
  [0.6875141, 0, 4.526403],
  [0.6968081, 0, 4.534893],
  [0.7007484, 0, 4.538464],
  [0.7135932, 0, 4.549988],
  [0.7220404, 0, 4.557472],
  [0.7301319, 0, 4.564571],
  [0.7384453, 0, 4.571795],
  [0.7473276, 0, 4.579436],
  [0.756104, 0, 4.586909],
  [0.764286, 0, 4.593808],
  [0.773123, 0, 4.601186],
  [0.7823582, 0, 4.608817],
  [0.7908456, 0, 4.615759],
  [0.7985747, 0, 4.622023],
  [0.8094933, 0, 4.630777],
  [0.8177974, 0, 4.637364],
  [0.8270469, 0, 4.644628],
  [0.8366132, 0, 4.652061],
  [0.8448381, 0, 4.658389],
  [0.854979, 0, 4.666111],
  [0.8649511, 0, 4.673619],
  [0.8738282, 0, 4.680233],
  [0.8836374, 0, 4.687467],
  [0.891036, 0, 4.69287],
  [0.9023809, 0, 4.70107],
  [0.9124227, 0, 4.708243],
  [0.9213457, 0, 4.714551],
  [0.9323015, 0, 4.722211],
  [0.9412742, 0, 4.728417],
  [0.9518962, 0, 4.735684],
  [0.9618311, 0, 4.742405],
  [0.9719691, 0, 4.749188],
  [0.9828935, 0, 4.756414],
  [0.9915185, 0, 4.762058],
  [1.003366, 0, 4.769725],
  [1.010058, 0, 4.774012],
  [1.024036, 0, 4.782866],
  [1.03475, 0, 4.789561],
  [1.042891, 0, 4.794597],
  [1.055052, 0, 4.802035],
  [1.066498, 0, 4.808947],
  [1.076762, 0, 4.815072],
  [1.086913, 0, 4.821062],
  [1.09861, 0, 4.827882],
  [1.104133, 0, 4.831072],
  [1.120381, 0, 4.840345],
  [1.132036, 0, 4.846896],
  [1.140136, 0, 4.851398],
  [1.153957, 0, 4.85899],
  [1.165802, 0, 4.865405],
  [1.171791, 0, 4.868616],
  [1.18685, 0, 4.876596],
  [1.199934, 0, 4.883424],
  [1.210477, 0, 4.888852],
  [1.222182, 0, 4.894804],
  [1.234526, 0, 4.900997],
  [1.246219, 0, 4.906785],
  [1.257264, 0, 4.912181],
  [1.270034, 0, 4.918337],
  [1.280272, 0, 4.923208],
  [1.292141, 0, 4.928783],
  [1.306248, 0, 4.935313],
  [1.318544, 0, 4.940917],
  [1.329988, 0, 4.946063],
  [1.343243, 0, 4.951937],
  [1.353878, 0, 4.956583],
  [1.367862, 0, 4.962605],
  [1.37973, 0, 4.967639],
  [1.391894, 0, 4.972724],
  [1.404727, 0, 4.978009],
  [1.41596, 0, 4.982568],
  [1.430599, 0, 4.988417],
  [1.442315, 0, 4.993023],
  [1.453316, 0, 4.997287],
  [1.468013, 0, 5.002894],
  [1.480925, 0, 5.007734],
  [1.494192, 0, 5.012628],
  [1.508148, 0, 5.017685],
  [1.513815, 0, 5.019712],
  [1.532421, 0, 5.026267],
  [1.545287, 0, 5.030707],
  [1.561001, 0, 5.036027],
  [1.573817, 0, 5.040284],
  [1.585691, 0, 5.044163],
  [1.601805, 0, 5.049327],
  [1.608909, 0, 5.051567],
  [1.627692, 0, 5.057384],
  [1.638932, 0, 5.060791],
  [1.655906, 0, 5.065834],
  [1.669415, 0, 5.06976],
  [1.683694, 0, 5.073825],
  [1.697202, 0, 5.07759],
  [1.707673, 0, 5.080457],
  [1.726056, 0, 5.08538],
  [1.732715, 0, 5.087128],
  [1.751063, 0, 5.091851],
  [1.768222, 0, 5.096143],
  [1.782314, 0, 5.099579],
  [1.797175, 0, 5.103116],
  [1.811624, 0, 5.106469],
  [1.825797, 0, 5.109677],
  [1.83132, 0, 5.110906],
  [1.852875, 0, 5.115586],
  [1.869167, 0, 5.119002],
  [1.883351, 0, 5.121892],
  [1.897773, 0, 5.12475],
  [1.913437, 0, 5.127764],
  [1.921284, 0, 5.129237],
  [1.94172, 0, 5.132966],
  [1.958117, 0, 5.135842],
  [1.968112, 0, 5.137547],
  [1.986251, 0, 5.140542],
  [2.003364, 0, 5.143255],
  [2.018648, 0, 5.145586],
  [2.02705, 0, 5.146831],
  [2.045052, 0, 5.149409],
  [2.064357, 0, 5.152042],
  [2.075021, 0, 5.153438],
  [2.093508, 0, 5.155758],
  [2.110018, 0, 5.157727],
  [2.125382, 0, 5.15947],
  [2.136314, 0, 5.160658],
  [2.15532, 0, 5.162621],
  [2.173051, 0, 5.164337],
  [2.188647, 0, 5.165754],
  [2.203172, 0, 5.166995],
  [2.220496, 0, 5.168379],
  [2.234588, 0, 5.169425],
  [2.251565, 0, 5.170594],
  [2.268377, 0, 5.171653],
  [2.280342, 0, 5.172346],
  [2.300326, 0, 5.173392],
  [2.31589, 0, 5.174111],
  [2.327134, 0, 5.174579],
  [2.348459, 0, 5.175344],
  [2.356286, 0, 5.175587],
  [2.381119, 0, 5.176216],
  [2.39576, 0, 5.176487],
  [2.406732, 0, 5.176643],
  [2.427506, 0, 5.176826],
  [2.445275, 0, 5.176866],
  [2.452103, 0, 5.176852],
  [2.478283, 0, 5.176655],
  [2.49397, 0, 5.176426],
  [2.51175, 0, 5.176065],
  [2.528126, 0, 5.17564],
  [2.54249, 0, 5.175192],
  [2.559014, 0, 5.174592],
  [2.577337, 0, 5.17382],
  [2.595601, 0, 5.172937],
  [2.612945, 0, 5.171996],
  [2.629386, 0, 5.171012],
  [2.642546, 0, 5.170158],
  [2.65387, 0, 5.169378],
  [2.676818, 0, 5.167667],
  [2.69464, 0, 5.166217],
  [2.708518, 0, 5.165014],
  [2.729915, 0, 5.163035],
  [2.745312, 0, 5.161517],
  [2.764683, 0, 5.159496],
  [2.781325, 0, 5.15766],
  [2.799716, 0, 5.155523],
  [2.813886, 0, 5.153801],
  [2.833994, 0, 5.151244],
  [2.851391, 0, 5.148922],
  [2.865653, 0, 5.146944],
  [2.884894, 0, 5.14417],
  [2.892941, 0, 5.142972],
  [2.913846, 0, 5.139762],
  [2.935644, 0, 5.13626],
  [2.95493, 0, 5.133031],
  [2.971951, 0, 5.130077],
  [2.989712, 0, 5.126893],
  [3.006586, 0, 5.12377],
  [3.02408, 0, 5.120432],
  [3.042723, 0, 5.116763],
  [3.058852, 0, 5.113494],
  [3.076727, 0, 5.10977],
  [3.090027, 0, 5.10693],
  [3.112924, 0, 5.101901],
  [3.130094, 0, 5.098015],
  [3.147512, 0, 5.09397],
  [3.153531, 0, 5.092549],
  [3.182821, 0, 5.085457],
  [3.199877, 0, 5.081193],
  [3.218212, 0, 5.0765],
  [3.235404, 0, 5.071995],
  [3.249616, 0, 5.068194],
  [3.267301, 0, 5.063369],
  [3.287441, 0, 5.057744],
  [3.300518, 0, 5.054016],
  [3.323501, 0, 5.047322],
  [3.341474, 0, 5.04196],
  [3.356041, 0, 5.037531],
  [3.377002, 0, 5.03103],
  [3.387385, 0, 5.027752],
  [3.413041, 0, 5.019492],
  [3.4295, 0, 5.014071],
  [3.448129, 0, 5.007819],
  [3.467033, 0, 5.00135],
  [3.484802, 0, 4.995154],
  [3.500621, 0, 4.989542],
  [3.518564, 0, 4.983068],
  [3.537764, 0, 4.976013],
  [3.555061, 0, 4.969543],
  [3.571582, 0, 4.963261],
  [3.591214, 0, 4.955667],
  [3.607517, 0, 4.949253],
  [3.627084, 0, 4.941427],
  [3.643672, 0, 4.93468],
  [3.661704, 0, 4.92723],
  [3.679268, 0, 4.919858],
  [3.697076, 0, 4.912263],
  [3.714745, 0, 4.90461],
  [3.731973, 0, 4.897033],
  [3.750166, 0, 4.888909],
  [3.76801, 0, 4.880817],
  [3.786753, 0, 4.872186],
  [3.79181, 0, 4.869834],
  [3.822044, 0, 4.855562],
  [3.839193, 0, 4.847306],
  [3.856925, 0, 4.838648],
  [3.874896, 0, 4.829745],
  [3.887603, 0, 4.823371],
  [3.909281, 0, 4.812349],
  [3.91654, 0, 4.808615],
  [3.941164, 0, 4.795788],
  [3.958175, 0, 4.786781],
  [3.979544, 0, 4.775296],
  [3.9973, 0, 4.765609],
  [4.013466, 0, 4.756672],
  [4.032022, 0, 4.746279],
  [4.042899, 0, 4.740116],
  [4.066324, 0, 4.726675],
  [4.070368, 0, 4.724329],
  [4.099268, 0, 4.707365],
  [4.1094, 0, 4.70133],
  [4.135229, 0, 4.685739],
  [4.153969, 0, 4.67424],
  [4.167242, 0, 4.665998],
  [4.186676, 0, 4.653787],
  [4.206289, 0, 4.641285],
  [4.222916, 0, 4.630547],
  [4.239707, 0, 4.61957],
  [4.255516, 0, 4.609113],
  [4.27342, 0, 4.597125],
  [4.289782, 0, 4.586035],
  [4.308175, 0, 4.57341],
  [4.325281, 0, 4.56152],
  [4.341166, 0, 4.550346],
  [4.358023, 0, 4.53835],
  [4.373354, 0, 4.527315],
  [4.392024, 0, 4.513713],
  [4.404765, 0, 4.504325],
  [4.425658, 0, 4.488747],
  [4.442936, 0, 4.475689],
  [4.459686, 0, 4.462877],
  [4.475271, 0, 4.450818],
  [4.492861, 0, 4.437048],
  [4.508566, 0, 4.424606],
  [4.52515, 0, 4.411319],
  [4.536657, 0, 4.402006],
  [4.558034, 0, 4.384503],
  [4.5738, 0, 4.371423],
  [4.586479, 0, 4.360797],
  [4.605051, 0, 4.345058],
  [4.623129, 0, 4.329537],
  [4.639584, 0, 4.315234],
  [4.654712, 0, 4.301935],
  [4.667705, 0, 4.290397],
  [4.683364, 0, 4.276348],
  [4.700311, 0, 4.260965],
  [4.717866, 0, 4.244829],
  [4.733648, 0, 4.230148],
  [4.750545, 0, 4.214242],
  [4.758678, 0, 4.206515],
  [4.781218, 0, 4.184863],
  [4.796567, 0, 4.169909],
  [4.812596, 0, 4.154114],
  [4.827563, 0, 4.139195],
  [4.842535, 0, 4.124105],
  [4.853438, 0, 4.113008],
  [4.873777, 0, 4.092067],
  [4.885858, 0, 4.079476],
  [4.904008, 0, 4.06034],
  [4.917091, 0, 4.046382],
  [4.929044, 0, 4.033507],
  [4.948025, 0, 4.012818],
  [4.96337, 0, 3.995869],
  [4.975276, 0, 3.982578],
  [4.992209, 0, 3.96346],
  [5.002691, 0, 3.951498],
  [5.021311, 0, 3.930002],
  [5.03556, 0, 3.913335],
  [5.049106, 0, 3.897311],
  [5.063443, 0, 3.880157],
  [5.078426, 0, 3.862016],
  [5.090656, 0, 3.847044],
  [5.106739, 0, 3.827118],
  [5.119522, 0, 3.81109],
  [5.133547, 0, 3.793303],
  [5.14885, 0, 3.773651],
  [5.160995, 0, 3.75787],
  [5.171114, 0, 3.744596],
  [5.189367, 0, 3.72035],
  [5.202958, 0, 3.70204],
  [5.210683, 0, 3.691534],
  [5.226015, 0, 3.670465],
  [5.241817, 0, 3.648438],
  [5.254813, 0, 3.630085],
  [5.26728, 0, 3.612266],
  [5.281341, 0, 3.591917],
  [5.293205, 0, 3.574531],
  [5.304977, 0, 3.557085],
  [5.319604, 0, 3.535126],
  [5.329793, 0, 3.519641],
  [5.343427, 0, 3.498674],
  [5.356795, 0, 3.477832],
  [5.366363, 0, 3.462739],
  [5.381101, 0, 3.439193],
  [5.392518, 0, 3.420699],
  [5.405385, 0, 3.399586],
  [5.417251, 0, 3.379851],
  [5.428494, 0, 3.360912],
  [5.440057, 0, 3.341185],
  [5.45194, 0, 3.320641],
  [5.458499, 0, 3.309179],
  [5.474306, 0, 3.281195],
  [5.484571, 0, 3.262738],
  [5.496404, 0, 3.24118],
  [5.508342, 0, 3.219106],
  [5.51909, 0, 3.198949],
  [5.525701, 0, 3.186415],
  [5.537555, 0, 3.163667],
  [5.547726, 0, 3.143867],
  [5.559845, 0, 3.119916],
  [5.5706, 0, 3.098329],
  [5.58247, 0, 3.074122],
  [5.591875, 0, 3.054652],
  [5.600345, 0, 3.036887],
  [5.612703, 0, 3.010563],
  [5.622285, 0, 2.989813],
  [5.630775, 0, 2.971166],
  [5.641745, 0, 2.946702],
  [5.648832, 0, 2.930661],
  [5.659865, 0, 2.905316],
  [5.670095, 0, 2.88139],
  [5.672857, 0, 2.874858],
  [5.683513, 0, 2.849355],
  [5.693543, 0, 2.824897],
  [5.704191, 0, 2.79843],
  [5.713327, 0, 2.77529],
  [5.723141, 0, 2.749967],
  [5.731597, 0, 2.727739],
  [5.739879, 0, 2.705589],
  [5.743943, 0, 2.694574],
  [5.751896, 0, 2.672739],
  [5.760561, 0, 2.648501],
  [5.771372, 0, 2.617571],
  [5.774703, 0, 2.607883],
  [5.783216, 0, 2.582753],
  [5.79232, 0, 2.555279],
  [5.801227, 0, 2.527755],
  [5.808657, 0, 2.504277],
  [5.814535, 0, 2.485355],
  [5.822767, 0, 2.458298],
  [5.829871, 0, 2.434404],
  [5.836291, 0, 2.412349],
  [5.843038, 0, 2.388663],
  [5.849621, 0, 2.365023],
  [5.85581, 0, 2.342292],
  [5.860878, 0, 2.323288],
  [5.867927, 0, 2.296243],
  [5.873483, 0, 2.274382],
  [5.879885, 0, 2.248557],
  [5.885513, 0, 2.225249],
  [5.889952, 0, 2.206441],
  [5.896263, 0, 2.179005],
  [5.899131, 0, 2.166248],
  [5.906445, 0, 2.132839],
  [5.911817, 0, 2.107426],
  [5.914716, 0, 2.093374],
  [5.920945, 0, 2.062329],
  [5.925963, 0, 2.036388],
  [5.930428, 0, 2.012533],
  [5.934515, 0, 1.989998],
  [5.937237, 0, 1.974584],
  [5.943016, 0, 1.940689],
  [5.946924, 0, 1.91676],
  [5.949997, 0, 1.897302],
  [5.954059, 0, 1.870619],
  [5.957743, 0, 1.845359],
  [5.961004, 0, 1.822051],
  [5.964242, 0, 1.797901],
  [5.967588, 0, 1.77175],
  [5.970444, 0, 1.748338],
  [5.972974, 0, 1.726604],
  [5.975371, 0, 1.705053],
  [5.978518, 0, 1.675069],
  [5.980733, 0, 1.652622],
  [5.983163, 0, 1.626436],
  [5.985089, 0, 1.604298],
  [5.987241, 0, 1.57779],
  [5.988724, 0, 1.558187],
  [5.990296, 0, 1.53591],
  [5.992299, 0, 1.504746],
  [5.993645, 0, 1.481429],
  [5.994993, 0, 1.455442],
  [5.995511, 0, 1.444532],
  [5.996705, 0, 1.416687],
  [5.997828, 0, 1.385361],
  [5.998633, 0, 1.357385],
  [5.999177, 0, 1.333287],
  [5.999521, 0, 1.313604],
  [5.999833, 0, 1.287581],
  [5.999986, 0, 1.261113],
  [5.999981, 0, 1.237358],
  [5.999827, 0, 1.211856],
  [5.999555, 0, 1.188721],
  [5.999064, 0, 1.161164],
  [5.998531, 0, 1.138723],
  [5.997794, 0, 1.113588],
  [5.997014, 0, 1.091315],
  [5.995908, 0, 1.064257],
  [5.994837, 0, 1.041381],
  [5.993553, 0, 1.016896],
  [5.991982, 0, 0.990066],
  [5.990346, 0, 0.9648244],
  [5.988781, 0, 0.942602],
  [5.987804, 0, 0.9295148],
  [5.984993, 0, 0.894556],
  [5.982862, 0, 0.8702147],
  [5.980927, 0, 0.8494011],
  [5.977893, 0, 0.8188043],
  [5.975122, 0, 0.7926688],
  [5.972357, 0, 0.7680018],
  [5.969483, 0, 0.7436633],
  [5.966517, 0, 0.7197318],
  [5.96346, 0, 0.6961637],
  [5.960248, 0, 0.6724558],
  [5.957049, 0, 0.6497978],
  [5.953232, 0, 0.6238526],
  [5.949191, 0, 0.5975385],
  [5.94529, 0, 0.5731319],
  [5.941519, 0, 0.5503643],
  [5.93714, 0, 0.5248588],
  [5.932897, 0, 0.5009935],
  [5.929243, 0, 0.4810607],
  [5.924883, 0, 0.4579529],
  [5.919477, 0, 0.4302481],
  [5.915275, 0, 0.4093609],
  [5.909619, 0, 0.382087],
  [5.904053, 0, 0.3560913],
  [5.899475, 0, 0.3352916],
  [5.894397, 0, 0.3127955],
  [5.887749, 0, 0.2841767],
  [5.882376, 0, 0.2616849],
  [5.8759, 0, 0.2352868],
  [5.873078, 0, 0.22401],
  [5.864274, 0, 0.189649],
  [5.857787, 0, 0.1650777],
  [5.852127, 0, 0.1441214],
  [5.844848, 0, 0.117785],
  [5.838323, 0, 0.09473085],
  [5.831072, 0, 0.06968838],
  [5.824364, 0, 0.04702735],
  [5.816832, 0, 0.02212751],
  [5.81181, 0, 0.005832672],
  [5.802128, 0, -0.02493393],
  [5.796745, 0, -0.04168582],
  [5.787406, 0, -0.07018673],
  [5.779076, 0, -0.09503961],
  [5.771751, 0, -0.1164751],
  [5.76303, 0, -0.1415086],
  [5.757121, 0, -0.1581802],
  [5.746733, 0, -0.1869608],
  [5.738223, 0, -0.2100496],
  [5.729645, 0, -0.2329053],
  [5.721101, 0, -0.2552713],
  [5.7137, 0, -0.274339],
  [5.702747, 0, -0.3020508],
  [5.696166, 0, -0.3184268],
  [5.684209, 0, -0.3476695],
  [5.675509, 0, -0.3685554],
  [5.665617, 0, -0.3919162],
  [5.656734, 0, -0.4125562],
  [5.6477, 0, -0.4332372],
  [5.637758, 0, -0.4556428],
  [5.630237, 0, -0.4723573],
  [5.616405, 0, -0.5025835],
  [5.606145, 0, -0.5245937],
  [5.596362, 0, -0.5452688],
  [5.584412, 0, -0.5701255],
  [5.573716, 0, -0.5920136],
  [5.565842, 0, -0.607919],
  [5.55305, 0, -0.6333946],
  [5.542503, 0, -0.6540675],
  [5.529467, 0, -0.6792262],
  [5.518259, 0, -0.7005186],
  [5.507285, 0, -0.7210741],
  [5.497172, 0, -0.739769],
  [5.485104, 0, -0.761775],
  [5.473805, 0, -0.7820897],
  [5.460796, 0, -0.8051445],
  [5.449986, 0, -0.8240371],
  [5.43707, 0, -0.8463047],
  [5.42492, 0, -0.8669574],
  [5.413409, 0, -0.8862685],
  [5.400046, 0, -0.9083817],
  [5.386714, 0, -0.9301302],
  [5.378462, 0, -0.9434364],
  [5.360657, 0, -0.9717579],
  [5.346879, 0, -0.9933202],
  [5.334977, 0, -1.011704],
  [5.32084, 0, -1.033257],
  [5.307419, 0, -1.053442],
  [5.296687, 0, -1.069392],
  [5.281089, 0, -1.092282],
  [5.267511, 0, -1.111932],
  [5.253105, 0, -1.132509],
  [5.240149, 0, -1.150779],
  [5.227844, 0, -1.167932],
  [5.211259, 0, -1.190748],
  [5.201407, 0, -1.204141],
  [5.184586, 0, -1.226739],
  [5.170461, 0, -1.245457],
  [5.154541, 0, -1.266277],
  [5.138914, 0, -1.286441],
  [5.125067, 0, -1.304083],
  [5.109483, 0, -1.323692],
  [5.095364, 0, -1.341238],
  [5.08203, 0, -1.357621],
  [5.064516, 0, -1.378866],
  [5.048998, 0, -1.397439],
  [5.033892, 0, -1.415296],
  [5.018305, 0, -1.433494],
  [5.002902, 0, -1.451257],
  [4.990675, 0, -1.465203],
  [4.971688, 0, -1.486598],
  [4.957454, 0, -1.502427],
  [4.943173, 0, -1.518136],
  [4.930458, 0, -1.531977],
  [4.910419, 0, -1.553518],
  [4.893835, 0, -1.571098],
  [4.878856, 0, -1.586788],
  [4.860923, 0, -1.605339],
  [4.843189, 0, -1.623443],
  [4.826638, 0, -1.640123],
  [4.819979, 0, -1.646776],
  [4.79879, 0, -1.667731],
  [4.777215, 0, -1.688735],
  [4.760126, 0, -1.705135],
  [4.743587, 0, -1.720815],
  [4.726722, 0, -1.736612],
  [4.708862, 0, -1.753131],
  [4.692094, 0, -1.768447],
  [4.676373, 0, -1.782642],
  [4.658682, 0, -1.798421],
  [4.639291, 0, -1.81549],
  [4.624367, 0, -1.828467],
  [4.609232, 0, -1.841487],
  [4.589664, 0, -1.858113],
  [4.568645, 0, -1.875716],
  [4.554253, 0, -1.887619],
  [4.534746, 0, -1.903558],
  [4.51778, 0, -1.917244],
  [4.500862, 0, -1.930728],
  [4.480818, 0, -1.946495],
  [4.463116, 0, -1.960235],
  [4.44291, 0, -1.975709],
  [4.429219, 0, -1.986069],
  [4.409454, 0, -2.00085],
  [4.392469, 0, -2.013386],
  [4.370491, 0, -2.029386],
  [4.353386, 0, -2.041666],
  [4.335013, 0, -2.054689],
  [4.314445, 0, -2.069069],
  [4.294926, 0, -2.08252],
  [4.280798, 0, -2.092141],
  [4.260155, 0, -2.106022],
  [4.242539, 0, -2.117706],
  [4.2221, 0, -2.131076],
  [4.200762, 0, -2.144826],
  [4.183272, 0, -2.155938],
  [4.164513, 0, -2.1677],
  [4.144722, 0, -2.179934],
  [4.126211, 0, -2.191216],
  [4.106845, 0, -2.202856],
  [4.087464, 0, -2.214339],
  [4.068426, 0, -2.225456],
  [4.047349, 0, -2.237582],
  [4.031361, 0, -2.246651],
  [4.010242, 0, -2.258463],
  [3.994854, 0, -2.266952],
  [3.971391, 0, -2.279701],
  [3.950235, 0, -2.291],
  [3.93137, 0, -2.30092],
  [3.914275, 0, -2.309782],
  [3.893017, 0, -2.320637],
  [3.872085, 0, -2.331146],
  [3.853588, 0, -2.340287],
  [3.834397, 0, -2.349626],
  [3.814427, 0, -2.359191],
  [3.793105, 0, -2.36923],
  [3.774874, 0, -2.377672],
  [3.752549, 0, -2.387836],
  [3.734484, 0, -2.395921],
  [3.712424, 0, -2.405622],
  [3.695428, 0, -2.412971],
  [3.673205, 0, -2.422415],
  [3.652754, 0, -2.430944],
  [3.641838, 0, -2.435432],
  [3.612595, 0, -2.447236],
  [3.593618, 0, -2.454728],
  [3.57178, 0, -2.463186],
  [3.561136, 0, -2.467244],
  [3.533927, 0, -2.477434],
  [3.513085, 0, -2.485058],
  [3.49137, 0, -2.492835],
  [3.47903, 0, -2.497179],
  [3.457228, 0, -2.504722],
  [3.439745, 0, -2.510648],
  [3.419182, 0, -2.517481],
  [3.390247, 0, -2.526843],
  [3.378925, 0, -2.530425],
  [3.349547, 0, -2.539515],
  [3.329688, 0, -2.545489],
  [3.310191, 0, -2.551221],
  [3.290579, 0, -2.556855],
  [3.268257, 0, -2.563106],
  [3.249393, 0, -2.568255],
  [3.228299, 0, -2.573869],
  [3.207283, 0, -2.579312],
  [3.188798, 0, -2.583974],
  [3.172343, 0, -2.588027],
  [3.148414, 0, -2.593758],
  [3.127123, 0, -2.598694],
  [3.112217, 0, -2.60206],
  [3.089336, 0, -2.60708],
  [3.066566, 0, -2.6119],
  [3.048328, 0, -2.615637],
  [3.029135, 0, -2.61945],
  [3.012143, 0, -2.622721],
  [2.984527, 0, -2.627833],
  [2.965058, 0, -2.631285],
  [2.944589, 0, -2.634778],
  [2.930574, 0, -2.637089],
  [2.913509, 0, -2.639815],
  [2.891788, 0, -2.643145],
  [2.875769, 0, -2.645501],
  [2.844196, 0, -2.649895],
  [2.822566, 0, -2.652714],
  [2.802836, 0, -2.65515],
  [2.784679, 0, -2.657279],
  [2.765397, 0, -2.659419],
  [2.74503, 0, -2.661546],
  [2.724492, 0, -2.663551],
  [2.704091, 0, -2.665405],
  [2.682225, 0, -2.667238],
  [2.664373, 0, -2.668617],
  [2.64401, 0, -2.670061],
  [2.625103, 0, -2.671277],
  [2.603247, 0, -2.672535],
  [2.584031, 0, -2.673509],
  [2.564513, 0, -2.674371],
  [2.544746, 0, -2.675116],
  [2.524686, 0, -2.675737],
  [2.505904, 0, -2.676196],
  [2.485356, 0, -2.676562],
  [2.464983, 0, -2.676784],
  [2.446528, 0, -2.676864],
  [2.42531, 0, -2.676814],
  [2.408181, 0, -2.676661],
  [2.385865, 0, -2.676312],
  [2.370288, 0, -2.675968],
  [2.34796, 0, -2.675329],
  [2.327453, 0, -2.674591],
  [2.311246, 0, -2.673906],
  [2.289095, 0, -2.672822],
  [2.273565, 0, -2.67196],
  [2.251129, 0, -2.670567],
  [2.231303, 0, -2.669188],
  [2.212633, 0, -2.667764],
  [2.195789, 0, -2.666373],
  [2.173673, 0, -2.664396],
  [2.154127, 0, -2.662503],
  [2.137986, 0, -2.660836],
  [2.126769, 0, -2.659623],
  [2.100384, 0, -2.65659],
  [2.080516, 0, -2.654141],
  [2.06674, 0, -2.652358],
  [2.041571, 0, -2.64892],
  [2.022743, 0, -2.646196],
  [2.004889, 0, -2.643493],
  [1.985478, 0, -2.640417],
  [1.971247, 0, -2.638073],
  [1.958351, 0, -2.635883],
  [1.931105, 0, -2.631049],
  [1.914145, 0, -2.627897],
  [1.894401, 0, -2.624089],
  [1.875093, 0, -2.620219],
  [1.857702, 0, -2.616609],
  [1.840234, 0, -2.612864],
  [1.821402, 0, -2.608691],
  [1.803067, 0, -2.604493],
  [1.784567, 0, -2.600121],
  [1.77194, 0, -2.597058],
  [1.750467, 0, -2.5917],
  [1.730919, 0, -2.586658],
  [1.7161, 0, -2.582731],
  [1.698778, 0, -2.578026],
  [1.679731, 0, -2.572705],
  [1.662672, 0, -2.56781],
  [1.646397, 0, -2.563024],
  [1.627673, 0, -2.557378],
  [1.609322, 0, -2.551697],
  [1.592687, 0, -2.546419],
  [1.584471, 0, -2.543767],
  [1.557809, 0, -2.534956],
  [1.542412, 0, -2.529721],
  [1.524599, 0, -2.523531],
  [1.508932, 0, -2.517967],
  [1.497896, 0, -2.513979],
  [1.477545, 0, -2.506475],
  [1.459161, 0, -2.499529],
  [1.448347, 0, -2.495369],
  [1.424772, 0, -2.486102],
  [1.409956, 0, -2.480139],
  [1.393354, 0, -2.47333],
  [1.375272, 0, -2.465757],
  [1.360769, 0, -2.459564],
  [1.343718, 0, -2.452145],
  [1.329822, 0, -2.445989],
  [1.311525, 0, -2.437728],
  [1.297158, 0, -2.431118],
  [1.280432, 0, -2.423284],
  [1.265833, 0, -2.416322],
  [1.25033, 0, -2.408801],
  [1.23437, 0, -2.400919],
  [1.219153, 0, -2.393272],
  [1.202676, 0, -2.384842],
  [1.193052, 0, -2.379845],
  [1.17434, 0, -2.369976],
  [1.158183, 0, -2.36129],
  [1.142511, 0, -2.352712],
  [1.127235, 0, -2.344208],
  [1.113832, 0, -2.336628],
  [1.099005, 0, -2.328111],
  [1.083856, 0, -2.319265],
  [1.068725, 0, -2.310282],
  [1.060608, 0, -2.305402],
  [1.041736, 0, -2.293885],
  [1.026448, 0, -2.28438],
  [1.016993, 0, -2.278422],
  [0.9987736, 0, -2.266766],
  [0.9852757, 0, -2.257979],
  [0.9727688, 0, -2.249721],
  [0.9569423, 0, -2.239107],
  [0.9435635, 0, -2.22999],
  [0.9304998, 0, -2.220958],
  [0.9159889, 0, -2.210772],
  [0.9062438, 0, -2.203839],
  [0.8884668, 0, -2.190999],
  [0.8773551, 0, -2.182843],
  [0.8633177, 0, -2.172395],
  [0.8492475, 0, -2.161758],
  [0.8400786, 0, -2.154735],
  [0.8234563, 0, -2.141818],
  [0.8112512, 0, -2.132178],
  [0.7993946, 0, -2.122684],
  [0.7854433, 0, -2.111348],
  [0.7736337, 0, -2.10161],
  [0.7614722, 0, -2.091443],
  [0.7487423, 0, -2.080647],
  [0.7373438, 0, -2.070842],
  [0.7274723, 0, -2.062245],
  [0.713511, 0, -2.049915],
  [0.7023001, 0, -2.039865],
  [0.6885209, 0, -2.027328],
  [0.6794157, 0, -2.018929],
  [0.6685429, 0, -2.008777],
  [0.6568754, 0, -1.997732],
  [0.642935, 0, -1.984327],
  [0.6322365, 0, -1.973882],
  [0.6218088, 0, -1.963564],
  [0.6094933, 0, -1.951204],
  [0.5985599, 0, -1.940067],
  [0.5896449, 0, -1.93087],
  [0.5790863, 0, -1.919839],
  [0.5670934, 0, -1.907122],
  [0.5564022, 0, -1.895615],
  [0.5462093, 0, -1.88449],
  [0.5350447, 0, -1.872127],
  [0.5254092, 0, -1.861305],
  [0.5155718, 0, -1.850106],
  [0.5036709, 0, -1.836351],
  [0.4959366, 0, -1.827286],
  [0.4849968, 0, -1.814292],
  [0.473841, 0, -1.800828],
  [0.4643254, 0, -1.789167],
  [0.4552596, 0, -1.777902],
  [0.4488263, 0, -1.769814],
  [0.4363701, 0, -1.753926],
  [0.4275322, 0, -1.742465],
  [0.4173396, 0, -1.729049],
  [0.4094899, 0, -1.718565],
  [0.3997445, 0, -1.705363],
  [0.3913331, 0, -1.693796],
  [0.3827729, 0, -1.681856],
  [0.3748164, 0, -1.6706],
  [0.3653727, 0, -1.657038],
  [0.3565927, 0, -1.644226],
  [0.3486342, 0, -1.632437],
  [0.3399739, 0, -1.619412],
  [0.3324265, 0, -1.607889],
  [0.3234851, 0, -1.594023],
  [0.3162785, 0, -1.582672],
  [0.3103919, 0, -1.573281],
  [0.2999909, 0, -1.556414],
  [0.2937942, 0, -1.546194],
  [0.2877634, 0, -1.53612],
  [0.2794843, 0, -1.52208],
  [0.2706397, 0, -1.506799],
  [0.2637386, 0, -1.494667],
  [0.2564282, 0, -1.481606],
  [0.2492554, 0, -1.468574],
  [0.2418206, 0, -1.45483],
  [0.2355742, 0, -1.443088],
  [0.2286878, 0, -1.42993],
  [0.2221797, 0, -1.41728],
  [0.215873, 0, -1.404816],
  [0.210026, 0, -1.39307],
  [0.2027097, 0, -1.378104],
  [0.1975322, 0, -1.367325],
  [0.1904767, 0, -1.352374],
  [0.185364, 0, -1.341342],
  [0.1784756, 0, -1.326202],
  [0.1726305, 0, -1.313095],
  [0.1673203, 0, -1.300969],
  [0.1616349, 0, -1.287746],
  [0.1567073, 0, -1.276074],
  [0.1502988, 0, -1.260586],
  [0.1451609, 0, -1.247903],
  [0.1401589, 0, -1.235316],
  [0.1350448, 0, -1.222189],
  [0.1298742, 0, -1.208636],
  [0.124795, 0, -1.195035],
  [0.1205416, 0, -1.183411],
  [0.115222, 0, -1.168556],
  [0.1111615, 0, -1.156967],
  [0.107013, 0, -1.144888],
  [0.1018925, 0, -1.129628],
  [0.09854126, 0, -1.119418],
  [0.09368849, 0, -1.104297],
  [0.08987308, 0, -1.092114],
  [0.08563304, 0, -1.07825],
  [0.08149743, 0, -1.064372],
  [0.07768226, 0, -1.051235],
  [0.07404757, 0, -1.0384],
  [0.07008862, 0, -1.024039],
  [0.0669179, 0, -1.012227],
  [0.0633533, 0, -0.9985934],
  [0.05990601, 0, -0.9850227],
  [0.05666041, 0, -0.9718689],
  [0.05409169, 0, -0.9611789],
  [0.05037427, 0, -0.9452319],
  [0.04748511, 0, -0.9324116],
  [0.04555249, 0, -0.9236106],
  [0.04171586, 0, -0.9055501],
  [0.03879595, 0, -0.8912243],
  [0.03694963, 0, -0.8818784],
  [0.0343132, 0, -0.8681093],
  [0.03156233, 0, -0.853152],
  [0.02926087, 0, -0.8401177],
  [0.02694368, 0, -0.8264554],
  [0.02493596, 0, -0.814127],
  [0.02291608, 0, -0.8012022],
  [0.02090096, 0, -0.7877175],
  [0.01922631, 0, -0.7760011],
  [0.01719522, 0, -0.7610738],
  [0.01561379, 0, -0.7488202],
  [0.01393056, 0, -0.7350703],
  [0.01230812, 0, -0.7209972],
  [0.0109055, 0, -0.7080546],
  [0.01031232, 0, -0.7023314],
  [0.008863688, 0, -0.6876105],
  [0.007499218, 0, -0.6725925],
  [0.006374836, 0, -0.6591488],
  [0.005092382, 0, -0.6422638],
  [0.004234791, 0, -0.6297444],
  [0.003432274, 0, -0.6168172],
  [0.002814531, 0, -0.6057892],
  [0.00221324, 0, -0.5938144],
  [0.001688957, 0, -0.5819585],
  [0.001108408, 0, -0.5664015],
  [0.0006864071, 0, -0.5522527],
  [0.000449419, 0, -0.5422879],
  [0.0001885891, 0, -0.5273941],
  [4.935265E-05, 0, -0.5140162],
  [7.152557E-07, 0, -0.5017183],
  [0, 0, -0.4999995],
  [0, 0, -0.4999995],
  [0, 0, -0.4999995]
]